module.exports = __webpack_public_path__ + "static/media/proj4_img3.797ce9cb.jpg";